export default __webpack_public_path__ + "i18n/translations/translation-ta.541bc2a4.json";